module.exports = __webpack_public_path__ + "img/searchiconWhite.461d3e20.svg";